<template>
    <div id="container-information-panel-pdf">
      <IndicatorsInformationCarousel :indicators="informationIndicators" />
      <IndicatorsInformationPdf :indicators="informationIndicators" />
    </div>
  </template>

  <script>

  import IndicatorsInformationCarousel from './IndicatorsInformationCarousel.vue'
  import IndicatorsInformationPdf from './IndicatorsInformationPdf.vue'
  import IndicatorsCarousel from './defaultInformationCarousel.js'

  export default {
    name: 'IndicatorsInformationSheet',

    props: {
      informationIndicators: {
        default: IndicatorsCarousel,
        type: Object
      }
    },

    components: {
      IndicatorsInformationCarousel,
      IndicatorsInformationPdf
    }
  }

  </script>

  <style scoped>

  #container-information-panel-pdf {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 3rem;
    min-height: 40rem;
  }

  @media (max-width: 769px) {
    #container-information-panel-pdf {
      justify-content: center;
    }
  }

  </style>